<template>
    <step-options-size
        v-if="itemData.custom?.['fj-group-type'] === 'size-width'"
        :item-data="itemData"
        class="pt-5 md:pt-0"
    />

    <step-options-buttons
        v-if="itemData.custom?.['fj-group-type'] === 'buttons'"
        :item-data="itemData"
    />

    <!-- :heading-text="itemData.name === 'Base' ? 'Base Leathers' : 'Select Color'" -->

    <step-options-personalization
        v-if="itemData.custom?.['fj-group-type'] === 'monogramming'"
        :item-data="itemData"
        class="pt-5 md:pt-0"
    />
</template>

<script>
    import StepOptionsSize from './StepOptionsSize.vue';
    import StepOptionsButtons from './StepOptionsButtons.vue';
    import StepOptionsPersonalization from './StepOptionsPersonalization.vue';

    export default {
        components: {
            StepOptionsSize,
            StepOptionsButtons,
            StepOptionsPersonalization,
        },

        props: {
            itemData: {
                type: Object,
                required: true,
            },
        },
    };
</script>
